import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { TARIFF_CARD_BASE_CLASSNAME } from './Constants';
import { createTariffCards } from './TariffCard';
createComponents(".".concat(TARIFF_CARD_BASE_CLASSNAME), createTariffCards, NO_PATTERN_BUSINESS_LOGIC);
